var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMid meet",
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "amex") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 48,
    height: 30,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "amex",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1-Copy-67"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#C5C5C8",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 29,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.4536563,11.0007559 L15.6199085,11.0007559 L15.6199085,18.724513 C14.6292449,16.1488225 13.6385292,13.5730739 12.6488549,11 L10.0699325,11 C9.04792339,13.6588973 8.02976738,16.3076772 7,18.986693 L8.82048627,18.986693 C9.04563235,18.3852896 9.26541534,17.7983645 9.48733315,17.2055667 L13.1539236,17.2055667 C13.3804755,17.809703 13.6031744,18.40378 13.8172298,18.9747149 L17.3341221,18.9747149 L17.3341221,12.5540664 C18.1881568,14.6975 19.0421915,16.8408173 19.8974238,18.9871 L21.4032054,18.9871 C22.260937,16.8350608 23.1140345,14.694709 23.9672882,12.5539501 L23.9672882,18.9788433 L25.6802,18.9788433 L25.6802,11 L22.8399436,11 C22.1457084,12.8188048 21.4560554,14.6256316 20.7332864,16.5192121 C19.9491282,14.6209799 19.2001166,12.8077571 18.4536563,11.0007559 L18.4536563,11.0007559 L18.4536563,11.0007559 Z M11.3907923,12.2502 C11.3907923,12.2502 12.4637348,15.1578306 12.6176,15.5752 L10.1606,15.5752 C10.5651794,14.4725262 11.3907923,12.2502 11.3907923,12.2502 L11.3907923,12.2502 Z M38.9080949,11.0138 C38.1814171,11.8807529 37.4448462,12.7595093 36.6897907,13.6603611 C35.9951876,12.7472406 35.3284415,11.8707518 34.6813254,11.0200797 L26.6924,11.0200797 L26.6924,19 L34.4670086,19 C35.1766598,18.1436297 35.9138034,17.2540581 36.6724517,16.3385536 C37.4065233,17.2566165 38.1200796,18.1490372 38.8004679,19 L40.9853957,19 C39.8826741,17.6412505 38.8307721,16.345124 37.7570011,15.022076 C38.8785717,13.6773397 39.9736911,12.3642346 41.1,11.0138 L38.9080949,11.0138 L38.9080949,11.0138 Z M32.2934412,17.4486333 L28.2172,17.4486333 L28.2172,15.7950125 L32.1459811,15.7950125 L32.1459811,14.1905834 L28.2240731,14.1905834 L28.2240731,12.6611629 L32.2870887,12.6611629 L32.2870887,11.2071 C33.3270679,12.4780604 34.3664742,13.7483813 35.4265,15.0439376 C34.3712125,16.2865808 33.3325351,17.5096869 32.2934412,18.7332 L32.2934412,17.4486333 L32.2934412,17.4486333 Z",
    id: "Path-Copy",
    fill: "#0071B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.a6b3b481cb604a1b5c83a1513538c3c4.svg";
export { ForwardRef as ReactComponent };